export default class Pauschalenart {
    constructor(
        id,
        name,
        icon,
        datum = {
            required: false,
        },
        uhrzeit = {
            required: false
        }
    )
    {
        this.id = id
        this.name = name
        this.icon = icon
        this.datum = Object.assign({ required: false }, datum)
        this.uhrzeit = Object.assign({ required: false }, uhrzeit)
    }

    getFirestore(){
        return {
            id: this.id,
            name: this.name,
            icon: this.icon,
            datum: this.datum,
            uhrzeit: this.uhrzeit
        }
    }
}